import { useState } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import loadable from '@loadable/component';
import classNames from 'classnames';

import {
    ClickElement,
    trackCustomerAccountButtonClick,
    trackCustomerAccountTextLinkClick,
} from '@jsmdg/tracking';
import { Link, LinkVariant, RenderType } from '@jsmdg/yoshi';
import { ProductPromotionType } from '../../../shared/enums';
import { useProduct } from '../../hooks/useProduct';
import styles from './StrikePriceInfo.module.scss';

const LoadableStrikePriceModal = loadable(async () => import('./StrikePriceModal'));

type Props = {
    readonly numTickets: number;
};

const messages = defineMessages({
    strikePrefix: {
        defaultMessage:
            '* Der Rabatt ist nicht auf andere Erlebnisse bei der Einlösung übertragbar.',
    },
    details: {
        defaultMessage: 'Details',
    },
});

const StrikePriceInfo = ({ numTickets }: Props): JSX.Element | null => {
    const [showStrikePriceModal, setShowStrikePriceModal] = useState(false);
    const { originalPrice, promotionType } = useProduct();
    const intl = useIntl();

    const handleDetailsClick = (): void => {
        setShowStrikePriceModal(true);
        trackCustomerAccountTextLinkClick(
            intl.formatMessage(messages.details),
            ClickElement.ClubDealStarTextPDP,
        );
    };

    const handleModalClose = (): void => {
        setShowStrikePriceModal(false);
        trackCustomerAccountButtonClick(ClickElement.CloseStarTextPopupPDP, 'x');
    };

    if (!originalPrice && promotionType !== ProductPromotionType.CustomerClub) {
        return null;
    }

    return (
        <>
            <div className={classNames(styles.strikePriceInfo, 'py-0 pt-3x pt-sm-3x pb-sm-3x')}>
                <span>
                    {intl.formatMessage(messages.strikePrefix)}{' '}
                    <Link
                        onClick={handleDetailsClick}
                        variant={LinkVariant.Brand}
                        as={RenderType.Button}
                    >
                        {intl.formatMessage(messages.details)}
                    </Link>
                </span>
            </div>
            {showStrikePriceModal && (
                <LoadableStrikePriceModal
                    isOpen={showStrikePriceModal}
                    handleOnClose={handleModalClose}
                    numTickets={numTickets}
                />
            )}
        </>
    );
};

export { StrikePriceInfo };
